<template>
  <div>
    <h2>Задачи</h2>

    <!-- add button -->
    <b-row class="mt-5 mb-2">
      <b-col>
        <b-button variant="primary" class="mb-1 mr-1" :to="{ name: 'Tasks'}">
          <b-icon-table></b-icon-table>
        </b-button>

        <b-button class="mb-1 mr-1" :to="{ name: 'TasksWeek' }">Неделя</b-button>

        <b-button class="mb-1" v-on:click="onCreateButton">Добавить</b-button>

        <task-modal :form="form" :isUpdate="isUpdate" @refresh="fetchTasks"></task-modal>
      </b-col>
    </b-row>

    <!-- Фильтр -->
    <b-card class="bg-light mb-3">
      <b-form size="sm">
        <b-form-row>
          <b-col>
            <b-form-group label="Ответственный:" label-size="sm">
              <multi-select
                v-model="taskFilter.responsible"
                :options="optionsResponsible"
                :searchable="true"
                :loading="isLoadingResponsible"
                :internal-search="false"
                :hide-selected="true"
                track-by="last_name"
                label="last_name"
                placeholder="Введите имя для поиска"
                selectLabel="Enter чтобы выбрать"
                :multiple="false"
                :allowEmpty="true"
                @search-change="asyncFindResponsible"
              >
                <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
                <template slot="noOptions">Начните вводить имя</template>
                <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
                <span slot="noResult">Не найдено</span>
                <template slot="beforeList">
                  <b-button v-if="taskFilter.responsible" block @click="taskFilter.responsible = ''" class="rounded-0">
                    Очистить
                  </b-button>
                </template>
              </multi-select>
            </b-form-group>
          </b-col>
          <!--<b-col>-->
          <!--  <b-form-group label="Статус:" label-size="sm">-->
          <!--    <b-form-select-->
          <!--      v-model="taskFilter.status"-->
          <!--      :options="expireOptions"-->
          <!--      class="mb-3"-->
          <!--      value-field="name"-->
          <!--      text-field="title"-->
          <!--      disabled-field="notEnabled"-->
          <!--    ></b-form-select>-->
          <!--  </b-form-group>-->
          <!--</b-col>-->
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button type="button" @click="initFilterData" size="sm">Сбросить фильтр</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>

    <!-- kanban -->
    <div class="board" v-drag-and-drop:options="options">
      <task-board v-for="item in expireOptions"
                  v-bind:key="item.name"
                  :status="item.name"
                  :tasks="filterTasksByExpireDate(item.name)"
                  :title="item.title"
                  :total="totalRowsKanban[item.name]"
                  v-on:draggedInto="setExpireStatus(item.name, $event)"
                  v-on:nextPage="page++"
                  @showTarget="show"
      ></task-board>
    </div>

  </div>
</template>
<script>
import TaskBoard from "../components/TaskBoard";
import TaskModal from "../components/TaskModal";
import {VueDraggableDirective} from 'vue-draggable';
import MultiSelect from 'vue-multiselect';
import commonMixin from '../mixins/common';
import 'vue2-datepicker/index.css';

export default {
  name: "TasksKanban",
  mixins: [commonMixin],
  components: {TaskBoard, TaskModal, MultiSelect},
  directives: {
    dragAndDrop: VueDraggableDirective
  },
  data() {
    return {
      options: {
        dropzoneSelector: 'div.column',
        draggableSelector: '.draggable-card',
        showDropzoneAreas: false,
        multipleDropzonesItemsDraggingEnabled: true,
      },
      page: 1,
      expireOptions: [
        {
          title: "Просроченные",
          name: "expired"
        },
        {
          title: "На сегодня",
          name: "today"
        },
        {
          title: "На завтра",
          name: "tomorrow"
        },
        {
          title: "На неделю",
          name: "week"
        },
        {
          title: "На месяц",
          name: "month"
        },
      ],
      tasks: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      sourceOptions: [
        {value: 'deal', text: 'Сделка'},
        {value: 'company', text: 'Компания'},
        {value: 'contact', text: 'Контакт'},
      ],
      searchQuery: {
        query: '',
        tags: []
      },
      isUpdate: false,
      isBusy: false,
      isBusyButton: false,
      isLoading: false,
      isLoadingDeal: false,
      isLoadingResponsible: false,
      isLoadingContact: false,
      isLoadingCompany: false,
      totalRows: 0,
      totalRowsKanban: {},
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      fields: [
        {key: 'content', label: 'Задача'},
        {key: 'object', label: 'Объект'},
        {key: 'responsible', label: 'Ответственный'},
        {key: 'status', label: 'Статус'},
        {key: 'due_date', label: 'Срок'},
        {key: 'created_at', label: 'Создано'},
        {key: 'actions', label: 'Действия'}
      ],
      items: [],
      optionsResponsible: [],
      optionsDeal: [],
      optionsContact: [],
      optionsCompany: [],
      statusOptions: [
        {value: 'todo', text: 'К выполнению'},
        {value: 'done', text: 'Готово'},
      ],
      form: {
        due_date: '',
        content: '',
        responsible: null,
        company: null,
        deal: null,
        contact: null,
        source: null,
        id: null,
        status: 'todo'
      },
      taskFilter: {
        query: '',
        responsible: '',
        status: ''
      },
    }
  },
  created() {
    if (localStorage.getItem('taskFilterLocal')) {
      try {
        this.taskFilter = JSON.parse(localStorage.getItem('taskFilterLocal'));
      } catch (e) {
        console.error(e)
        this.taskFilter.query = ''
        this.taskFilter.responsible = ''
        this.taskFilter.status = ''
      }
    }
  },
  mounted() {
    let id = this.$route.hash.replace(/^#+/g, '');
    if (id) {
      this.show(id);
    }
    this.fetchTasks();
  },
  watch: {
    "page": {
      handler: function (data) {
        if (data) {
          this.fetchTasks();
        }
      },
      immediate: false,
      deep: false
    },
    'taskFilter': {
      handler: function (data) {
        if (data) {
          localStorage.setItem('taskFilterLocal', JSON.stringify(data));
          this.fetchTasks();
        }
      },
      immediate: false,
      deep: true
    },
  },
  methods: {
    initFilterData() {
      this.taskFilter.query = ''
      this.taskFilter.responsible = ''
      this.taskFilter.status = ''
    },
    fetchTasks() {
      if (!this.loading)
        this.loading = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/', {
        params: {
          page: this.page,
          kanban: 1,
          query: this.taskFilter.query,
          responsible: this.taskFilter.responsible.id,
        }
      }).then(response => {
        if (this.page === 1) {
          this.tasks = response.data.tasks;
        } else {
          this.tasks = this.tasks.concat(response.data.tasks);
        }
        this.totalRows = response.data.totalRows;
        this.totalRowsKanban = response.data.totalRowsKanban;
        this.loading = false;
      })
        .catch((error) => {
          console.error(error);
          if (this.page === 1) {
            this.tasks = [];
          }
          this.loading = false;
        });
    },
    filterTasksByExpireDate(expire) {
      return this.tasks.filter(task => task.expire === expire);
    },
    setExpireStatus(status, ids) {
      this.tasks = this.tasks.map(obj =>
        obj.id === (ids[0] * 1) ? {...obj, status: status} : obj
      );
      this.axios.patch(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + ids[0], {status: status})
        .then(response => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
        .then(() => {
          this.fetchTasks();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onCreateButton() {
      this.form.due_date = '';
      this.form.content = '';
      this.form.responsible = null;
      this.form.company = null;
      this.form.deal = null;
      this.form.contact = null;
      this.form.source = null;
      this.form.id = null;
      this.form.status = 'todo';
      this.isUpdate = false;

      this.$bvModal.show('task-modal');
    },
    submitSearch(evt) {
      evt.preventDefault();
      this.fetchTasks();
    },
    show(id) {
      this.isUpdate = true;
      this.error = false;
      this.form.id = id;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id, {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.form = response.data.task;
              this.$bvModal.show('task-modal');
            } else {
              console.log(response.data.message);
            }
          }
        });
    },
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
  },
}
</script>

<style>
.hidden-overflow {
  overflow: hidden;
  white-space: pre-wrap;
}

.board {
  display: flex;
  flex-flow: row nowrap;
  max-width: calc(100vw - 200px);
}
</style>
